module.exports = __webpack_public_path__ + "static/img/thumb-03.fe15061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/thumb/thumb-03.png
// module id = QDhc
// module chunks = 150